export const HeroSection = () => (
  <section className="pt-24 pb-16 bg-gray-50 text-center relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="lg:max-w-4xl mx-auto">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tighter text-gray-900 leading-tight">
          Modern Solutions, <span className="text-teal-600">Built to Evolve</span>
        </h1>
        <p className="mt-4 sm:mt-6 text-lg sm:text-xl text-gray-500 max-w-xl mx-auto">
          We craft stunning, performance-driven web applications and digital strategies tailored to your unique business needs.
        </p>
        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4">
          <a href="#services" className="px-8 py-3 text-lg font-semibold text-white bg-teal-600 rounded-xl shadow-lg hover:bg-teal-700 transition duration-300 transform hover:translate-y-[-2px] hover:shadow-xl">
            View Services
          </a>
          <a href="#contact" className="px-8 py-3 text-lg font-semibold text-teal-600 bg-white border-2 border-teal-600 rounded-xl shadow-lg hover:bg-teal-50 transition duration-300 transform hover:translate-y-[-2px] hover:shadow-xl">
            Start a Project
          </a>
        </div>
      </div>
    </div>
  </section>
);